import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import * as actionTypes from '../constants/actionTypes';
import initialState from './initialState';

const invoiceDataReducer = (state = initialState.invoice, action: any) => {
  const stateClone = cloneDeep(state);

  switch (action.type) {
    case actionTypes.INVOICE_DATA_LOADED:
      set(stateClone, 'data', get(action, 'payload.invoiceData', {}));
      return stateClone;
    default:
      return state;
  }
};

export default invoiceDataReducer;
